import React, { Suspense } from 'react';

import { Col, Container, Row } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const Login = React.lazy(() => import('./Login'));

const CarouselSlide = React.lazy(() => import('./CarouselSlide'));

library.add(faExclamationCircle);

//TODO: Need to rewrite clean CSS classes
export default () => (
  <Container className="bg-light-blue mtop30 mx-0 px-0 m-auto">
    <Row className="h-100">
      <Col className="my-auto px-0">
        <Row className="w-80 mx-auto">
          <Col md={6} lg={6} sm={12} xs={12}>
            <Suspense
              fallback={<i className="fa-li fa fa-spinner fa-spin"></i>}
            >
              <CarouselSlide />
            </Suspense>
          </Col>

          <Col md={6} lg={6} sm={12} xs={12}>
            <div className="loginform-border">
              <div className="login-form-greeting">
                <h1>Welcome to Admin Center</h1>

                <h3 className="signcontinue">Please log in to your account</h3>
              </div>

              <Suspense
                fallback={<i className="fa-li fa fa-spinner fa-spin"></i>}
              >
                <Login />
              </Suspense>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  </Container>
);
